import React, { FC } from 'react';

import {
  useAppSettings,
  useBlogPosts,
  useCanEditMember,
  useMember,
} from '../../../../contexts/widgets';
import Title from './Title';
import EmptyState from './EmptyState';
import PostList from './PostList';
import { shouldForceEmptyState } from './hooks';

export const BlogPosts: FC = () => {
  const { blogPosts } = useMember();
  const { canEditMember } = useCanEditMember();
  const appSettings = useAppSettings();
  const shouldShowEmptyState = canEditMember && !blogPosts.length;
  const { posts, paging, arePostsLoading } = useBlogPosts();

  return (
    <>
      <Title postCount={paging?.total} />
      {shouldShowEmptyState || shouldForceEmptyState(appSettings) ? (
        <EmptyState />
      ) : (
        <PostList
          posts={posts}
          paging={paging}
          arePostsLoading={arePostsLoading}
        />
      )}
    </>
  );
};
